export default __webpack_public_path__ + "static/media/helper-type.55764e66.png";